import React, { memo, ReactElement } from 'react'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import AssetImage from '../../Asset'

/* eslint-disable @typescript-eslint/no-var-requires */
const FALLBACK_ICON = require('../../../../assets/defaultImage/team/Team.svg')

type FallbackProps = {
    width?: string | number
} & TestID

const TeamImageFallback = ({ width = '100%', testID }: FallbackProps): ReactElement => {
    return <AssetImage imageUrl={FALLBACK_ICON} testID={testID} width={width} height={width} />
}

export default memo(TeamImageFallback)
